// Lazy-load the Razorpay Checkout script
let _loadingPromise = null;

export const loadRazorpayScript = () => {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.Razorpay) return Promise.resolve(true);
  if (_loadingPromise) return _loadingPromise;
  _loadingPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      _loadingPromise = null;
      resolve(false);
    };
    document.body.appendChild(script);
  });
  return _loadingPromise;
};

export const formatMoney = (amount, currency) => {
  try {
    const formatter = new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    });
    return formatter.format(Number(amount) || 0);
  } catch {
    const symbol = currency === 'INR' ? '₹' : '$';
    return `${symbol}${Number(amount || 0).toFixed(2)}`;
  }
};
